require("packs/bookmarks")
require("packs/forum_filters")
import { createPopper } from '@popperjs/core';
import "stylesheets/discussions";
import { setEvents } from "packs/bookmarks";
import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';
import { fetchAPI } from "packs/api";
import { staggerCards } from "packs/card_stagger";
window.Swiper = Swiper; // Assign Swiper to the window object to make it globally accessible
Swiper.use([Navigation, Pagination, FreeMode]); // So that swiper can use pagination - without it we cannot use

// Global page counter for infinite scroll (can be reset by filters)
window.forumPage = 2;
window.forumLoading = false;
window.forumFilterActive = false; // Flag to stop infinite scroll when filter is applied

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('scroll', function() {
    // Don't load more if filter is active (AJAX filter applied without page reload)
    if (window.forumFilterActive) return;
    const paginationEl = document.getElementById("append_pagination");
    const hasMore = paginationEl?.dataset.hasMore !== 'false';
    
    if (!window.forumLoading && hasMore && isElementInViewport(paginationEl)) {
      window.forumLoading = true;
      document.getElementById("pagination-animation")?.classList.remove("hidden");
      var params = new URLSearchParams(window.location.search);
      var paramsObject = {page: window.forumPage}
      for (const [key, value] of params) {
          paramsObject[key] = value;
      }
      var url = window.location.href.split('?')[0];
      fetchAPI(url, "GET", paramsObject, "script").then(response => {
        const updatedPaginationEl = document.getElementById("append_pagination");
        const stillHasMore = updatedPaginationEl?.dataset.hasMore !== 'false';
        
        if (stillHasMore) {
          window.forumPage += 1;
        }
        window.forumLoading = false;
        document.getElementById("pagination-animation")?.classList.add("hidden");
        setEvents();
        card_click();
        staggerCards('.list-view', '.card, .discussion-card');
        setTimeout(recalculateHeight, 100);
      }).catch(error => {
        window.forumLoading = false;
        document.getElementById("pagination-animation")?.classList.add("hidden");
      });
    }
  });

  function isElementInViewport(el) {
    if (!el || el.style.display === 'none') {
      return false;
    }
    
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function recalculateHeight() {
    document.documentElement.scrollHeight;
  }

  const swiperContainer = document.querySelector('.test-swiper');
  if (!swiperContainer) return;

  let swiperOfferSlider = new Swiper('.test-swiper', {
    spaceBetween: window.innerWidth < 768 ? 0 : 10,
    slidesPerView: 3,
    freeMode: true,
    loop: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
    },
    breakpoints: {
      // When window width is <= 768px
      340: {
        slidesPerView: 1.5,
        pagination: false
      },
      380: {
        slidesPerView: 1.6,
        pagination: false
      },
      400: {
        slidesPerView: 1.8,
        pagination: false
      },
      768: {
        slidesPerView: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      }
    },
    onInit: function(swiperOfferSlider){
      if (swiperOfferSlider.slides.length < 5) {
        const swiperContainer = document.querySelector(".test-swiper");
        if (swiperContainer) {
          const nextButton = swiperContainer.querySelector(".swiper-button-next");
          const prevButton = swiperContainer.querySelector(".swiper-button-prev");
          if (nextButton) nextButton.style.display = "none";
          if (prevButton) prevButton.style.display = "none";
        } 
      }    
    },
    onResize: function(swiperOfferSlider) {
      swiperOfferSlider.update(); // Update Swiper instance on resize
    }
  });

  let discuss_read_more = document.getElementById('discuss-read-more');
  discuss_read_more?.addEventListener('click', function(){
    let discuss_content =  document.querySelector('.discuss-content');
    discuss_content.classList.toggle('line-clamp-2');

    if (discuss_content.classList.contains('line-clamp-2')) {
      discuss_read_more.textContent = '...'+ I18n.t("read_more");
    } else {
      discuss_read_more.textContent = I18n.t("less");;
    }
  });

  function changeCardView(view) {
    let currentUrl = new URL(window.location.href);
    let displayViewParam = 'display_view';
    let displayViewValue = view;
    currentUrl.searchParams.set(displayViewParam, displayViewValue);
    window.location.href = currentUrl;
  }
  document.querySelectorAll('.change-display-view').forEach(display => {
    display.addEventListener('click', function() {
      changeCardView(this.dataset.view);
    });
  })

  // Locked discussions tooltip logic
  const button = document.querySelector('#locked-button');
  const tooltip = document.querySelector('#locked-tooltip');
  if (button && tooltip) {
    let popperInstance = createPopper(button, tooltip, {
      placement: 'top-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    });
    function popperTooltipShow() {
      tooltip.setAttribute('data-show', '');
    
      // We need to tell Popper to update the tooltip position
      // after we show the tooltip, otherwise it will be incorrect
      popperInstance.update();
    }
    
    function popperTooltipHide() {
      tooltip.removeAttribute('data-show');
    }
    
    const showEvents = ['mouseenter', 'focus'];
    const hideEvents = ['mouseleave', 'blur'];
    
    showEvents.forEach((event) => {
      button.addEventListener(event, popperTooltipShow);
    });
    
    hideEvents.forEach((event) => {
      button.addEventListener(event, popperTooltipHide);
    });
  }

  // Locked discussions tooltip logic - END
});

let forumMerchantList = [];
let forumDisplayArr = [];
